import { render, staticRenderFns } from "./AuthorizeEntryPerson.vue?vue&type=template&id=9b31a02c"
import script from "./AuthorizeEntryPerson.vue?vue&type=script&lang=js"
export * from "./AuthorizeEntryPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports